import { motion } from "framer-motion";
import { Crown, Sparkles, ShieldCheck, Ticket, Image, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/contexts/I18nContext";

const PremiumSection = () => {
  const { t } = useI18n();

  const perks = [
    {
      icon: Sparkles,
      title: t('premium.item.aiIntegration.title'),
      description: t('premium.item.aiIntegration.desc'),
    },
    {
      icon: Image,
      title: t('premium.item.image.title'),
      description: t('premium.item.image.desc'),
    },
    {
      icon: Ticket,
      title: t('premium.item.tickets.title'),
      description: t('premium.item.tickets.desc'),
    },
    {
      icon: ShieldCheck,
      title: t('premium.item.security.title'),
      description: t('premium.item.security.desc'),
    },
    {
      icon: Bot,
      title: t('premium.item.automation.title'),
      description: t('premium.item.automation.desc'),
    },
  ];

  return (
    <section id="premium" className="py-20 px-6 relative">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="gradient-text">{t('premium.title')}</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('premium.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {perks.map((perk, index) => (
            <motion.div
              key={perk.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="glass-card p-6"
            >
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-500 to-yellow-400 flex items-center justify-center mb-4">
                <perk.icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{perk.title}</h3>
              <p className="text-sm text-muted-foreground">{perk.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <Button className="btn-gradient border-0 px-8 py-6 text-lg">
            <Crown className="w-5 h-5 mr-2" />
            {t('premium.cta')}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PremiumSection;
